import { ConfigField, KrEndangeredAreaFormTypes, KrLandslideFormTypes } from "../../../../../contexts/krFormContext";
import { poFormTypes } from "../../../../../contexts/poFormContext";
import { ObjectType, PatternType } from "../../../../../contexts/types/card";
import { createValidationKrForm, createValidationPoForm, validationErrorsKrForm, validationErrorsPoForm } from "../../../../../helpers/validation/validation";
import { CardsVaildationRequest, StatusValidationCardProps } from "../../../../../services/registrationCardService/types/registrationCardServiceProps";
import { AutomaticVerificationModalProps, OptionsForCards, TypeOfCard } from "./types/automaticVerificationModalProps";
import { changeValidationStatus } from "../../../../../services/registrationCardService/registrationCardService";
import { notifyError, notifySuccess } from "../../../../../components/snackbar/snackbar";
import { setTaskValidStatus } from "../../../../../database/indexedDbReadWrite";
import { Dictionary } from "../../../../../helpers/dictionariesFromLayers";

export const checkValidation = (card: KrLandslideFormTypes | KrEndangeredAreaFormTypes | poFormTypes, cardType: TypeOfCard, dictionariesForValidation?: Dictionary) => {
    if (cardType === TypeOfCard.landslide) {
        let landslideCard = card as KrLandslideFormTypes;
        const cardType = landslideCard.landslideAttributes?.wersja;
        const patternType = cardType ? cardType : PatternType.P2007;
        let config: ConfigField = {
            Validation: createValidationKrForm(landslideCard, ObjectType.KRO, patternType, dictionariesForValidation),
            check: true
        };
        landslideCard.config = config;
        const lAttributes = landslideCard.landslideAttributes;
        if (lAttributes !== null && (
            lAttributes?.zabezpieczeniE_OPIS === null ||
            lAttributes?.zabezpieczeniE_OPIS === "" ||
            lAttributes?.zabezpieczeniE_OPIS === undefined)
        ) {
            landslideCard.landslideAttributes!.zabezpieczeniE_OPIS = "Nie wykonano";
            landslideCard.landslideAttributes!.czY_ZABEZPIECZONE = 0;
        }
        landslideCard = validationErrorsKrForm(landslideCard, ObjectType.KRO, patternType, true, dictionariesForValidation);
        return landslideCard;
    }
    if (cardType === TypeOfCard.endangeredArea) {
        let endangeredAreaCard = card as KrEndangeredAreaFormTypes;
        const cardType = endangeredAreaCard.endangeredAreaAttributes?.wersjA_KARTY;
        const patternType = cardType ? cardType : PatternType.P2007;
        let config: ConfigField = {
            Validation: createValidationKrForm(endangeredAreaCard, ObjectType.KRTZ, patternType),
            check: true
        };
        endangeredAreaCard.config = config;
        endangeredAreaCard = validationErrorsKrForm(endangeredAreaCard, ObjectType.KRTZ, patternType, true, dictionariesForValidation);
        return endangeredAreaCard;
    }
    if (cardType === TypeOfCard.protocol) {
        let protocolCard = card as poFormTypes;
        var config: ConfigField = {
            Validation: createValidationPoForm(protocolCard),
            check: false
        };
        protocolCard.config = config;
        protocolCard = validationErrorsPoForm(protocolCard);
        return protocolCard;
    }
    return undefined;
}

export const PrepareValidations = (props: AutomaticVerificationModalProps, elements: OptionsForCards[], api: any, local?: boolean, dictionariesForValidation?: Dictionary) => {
    if (props && props.cards) {
        var statusValidationChanges: CardsVaildationRequest[] = [];
        if (props.cards.populateLandslideCardResponse && props.cards.populateLandslideCardResponse.length > 0) {
            for (let i = 0; i < props.cards.populateLandslideCardResponse.length; i++) {
                let landslide = checkValidation(props.cards.populateLandslideCardResponse[i], TypeOfCard.landslide, dictionariesForValidation);
                elements.push(
                    {
                        name: props.cards.populateLandslideCardResponse[i].landslideAttributes?.numeR_IDENTYFIKACYJNY?.toString(),
                        validationType: landslide?.config?.isValid ? 3 : 1,
                        card: landslide,
                        cardType: 1
                    },
                )
                let statusValidation: CardsVaildationRequest = {
                    isValid: landslide?.config?.isValid ? 1 : 0,
                    waitingRoomId: landslide?.waitingRoomGlobalId
                }
                statusValidationChanges.push(statusValidation);
            }
        }
        if (props.cards.populateEndangeredAreaCardResponse && props.cards.populateEndangeredAreaCardResponse.length > 0) {
            for (let i = 0; i < props.cards.populateEndangeredAreaCardResponse.length; i++) {
                let endangeredArea = checkValidation(props.cards.populateEndangeredAreaCardResponse[i], TypeOfCard.endangeredArea, dictionariesForValidation);
                elements.push(
                    {
                        name: props.cards.populateEndangeredAreaCardResponse[i].endangeredAreaAttributes?.numeR_IDENTYFIKACYJNY?.toString(),
                        validationType: endangeredArea?.config?.isValid ? 3 : 1,
                        card: endangeredArea,
                        cardType: 2
                    },
                )
                let statusValidation: CardsVaildationRequest = {
                    isValid: endangeredArea?.config?.isValid ? 1 : 0,
                    waitingRoomId: endangeredArea?.waitingRoomGlobalId
                }
                statusValidationChanges.push(statusValidation);
            }
        }
        if (props.cards.populateProtocolFormResponse && props.cards.populateProtocolFormResponse.length > 0) {
            for (let i = 0; i < props.cards.populateProtocolFormResponse.length; i++) {
                let protocol = checkValidation(props.cards.populateProtocolFormResponse[i], TypeOfCard.protocol);
                elements.push(
                    {
                        name: props.cards.populateProtocolFormResponse[i].protocolAttributes?.obiekT_NUMER_IDENTYFIKACYJNY?.toString(),
                        validationType: protocol?.config?.isValid ? 3 : 1,
                        card: protocol,
                        cardType: 3
                    },
                )
                let statusValidation: CardsVaildationRequest = {
                    isValid: protocol?.config?.isValid ? 1 : 0,
                    waitingRoomId: protocol?.waitingRoomGlobalId
                }
                statusValidationChanges.push(statusValidation);
            }
        }
        if(local){
            const PromiseArray: Promise<any>[] = [];
            for (let i = 0; i < statusValidationChanges.length; i++) {
                PromiseArray.push(setTaskValidStatus(statusValidationChanges[i].waitingRoomId, statusValidationChanges[i].isValid ? "pozytywna" : "negatywna"));
            }
            if (PromiseArray.length > 0) {
                return Promise.all(PromiseArray).then((response) => {
                    notifySuccess({message: "Statusy walidacji kart zostały zaktualizowane"});
                }).catch(() => {
                    notifyError({message: "Błąd podczas aktualizacji statusu"});
                })
            }
        }
        else{
            var statusValidationCardProps: StatusValidationCardProps = {
                apiBase: api.apiUrl + api.apiVersion,
                waitingRoomAttr: statusValidationChanges
            }
            return new Promise((resolve, reject) => {
                changeValidationStatus(statusValidationCardProps).then((response: any) => {
                    resolve(response);
                }).catch((error) => {
                    reject(error);
                })
            })
        }
    }
}